import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme.js';
export default css `
    ${componentStyles}

    .container {
        ${theme.spacings.cssPadding('XS')};
        width: 50px;
        border-radius: var(--sgdf-border-radius-medium);
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        /* border: 1px solid var(--sgdf-color-gray-200); */
    }

    .container:hover {
        ${theme.colors.cssBackground('secondary', 'hover')};
    }

    .is-selected {
        ${theme.colors.cssBackground('secondary')};
    }

    .weekday {
        ${theme.texts.cssBody('normal')};
        ${theme.colors.cssColor('text-default')};
    }

    .day {
        ${theme.texts.cssBody('bold')};
        ${theme.colors.cssColor('text-default')};
    }
`;
//# sourceMappingURL=day-selector-item.styles.js.map